module.exports = __webpack_public_path__ + "img/A1.4ef59c5c.svg";